import { render, staticRenderFns } from "./TagFilters.vue?vue&type=template&id=d3d9c80a&scoped=true&lang=html&"
import script from "./TagFilters.vue?vue&type=script&lang=js&"
export * from "./TagFilters.vue?vue&type=script&lang=js&"
import style0 from "./TagFilters.vue?vue&type=style&index=0&id=d3d9c80a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d9c80a",
  null
  
)

export default component.exports